var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedDetail,
            expression: "selectedDetail",
          },
        ],
        staticClass: "form-control",
        on: {
          change: [
            function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.selectedDetail = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
            _vm.updateCustomData,
          ],
        },
      },
      [
        _c("option", { attrs: { disabled: "", selected: "", value: "-1" } }, [
          _vm._v("Выберите или добавьте preset"),
        ]),
        _vm._v(" "),
        _vm._l(_vm.details, function (detail, index) {
          return _c("option", { domProps: { value: index } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.alias.calculatedRate) +
                ": " +
                _vm._s(detail.calculatedRate) +
                "\n      " +
                _vm._s(_vm.alias.ratePercent) +
                ": " +
                _vm._s(detail.ratePercent) +
                "\n      " +
                _vm._s(_vm.alias.baseMargin) +
                ": " +
                _vm._s(detail.baseMargin) +
                "\n      " +
                _vm._s(_vm.alias.deliveryPercent) +
                ": " +
                _vm._s(detail.deliveryPercent) +
                "\n      " +
                _vm._s(_vm.alias.delivery) +
                ": " +
                _vm._s(detail.delivery) +
                "\n    "
            ),
          ])
        }),
      ],
      2
    ),
    _vm._v(" "),
    this.$can("changeCalculationPresets")
      ? _c("div", { staticClass: "text-right" }, [
          _c(
            "div",
            { staticClass: "btn-group" },
            [
              _c("LoadingButton", {
                attrs: {
                  title: "Добавить текущие данные в preset",
                  className: "btn btn-outline-success btn-xs",
                  onClick: _vm.addToPreset,
                  type: "button",
                  loading: _vm.loading,
                  color: _vm.$constants.SUCCESS_COLOR,
                },
              }),
              _vm._v(" "),
              _c("LoadingButton", {
                attrs: {
                  title: "Отметить как избранный preset",
                  className: "btn btn-outline-info btn-xs",
                  onClick: _vm.markAsFavorite,
                  loading: _vm.loading,
                  type: "button",
                  color: _vm.$constants.PRIMARY_COLOR,
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }